import { useContext } from "react"

import {
  HelpdeskContext,
  clearCategoryResults,
  clearSearchResults,
  fetchHelpdeskSearchResults,
} from "contexts/helpdesk"

/**
 * High Order Component for passing helpdesk props
 * @param {React Component} WrappedComponent
 */
const withHelpdesk = (WrappedComponent) => (props) => {
  const { state, dispatch } = useContext(HelpdeskContext)
  const InternalHelpdesk = (props) => {
    return <WrappedComponent {...props} />
  }

  const mapStateToProps = {
    categories: state?.categories,
    categoryResults: state.categoryResults,
    collections: state.collections,
    searchResults: state.searchResults,
  }
  const mapDispatchToProps = {
    clearResults: () => {
      dispatch(clearCategoryResults())
      dispatch(clearSearchResults())
    },
    fetchResults: (query) => {
      fetchHelpdeskSearchResults(query, dispatch, state)
    },
  }

  const combineProps = {
    ...props,
    ...mapStateToProps,
    ...mapDispatchToProps,
  }

  return InternalHelpdesk(combineProps)
}

export default withHelpdesk
